export const nameKey = 'http://pms.coentunnelcompany.nl/rdl#hasName'
export const quarterNode = 'http://pms.coentunnelcompany.nl/rdl#Kwartaal'
export const typeRelation = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type'

export const getQuarters = async (typeRelation, quarterNode, nameKey) => {
  return await new Weaver.Query()
    .hasRelationOut(typeRelation, quarterNode)
    .order([nameKey])
    .find()
}

export const getBbvs = async () => {
  const map = {};
  const iterator = await new Weaver.Sparql(`
  PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
  PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
  PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
  PREFIX cti: <http://pms.coentunnelcompany.nl/instance#>
  PREFIX ct: <http://pms.coentunnelcompany.nl/rdl#>
  SELECT ?quarter ?bbv
  WHERE {
    ?quarter    ct:hasProperty     ?p .
    ?p          rdf:type           ct:BrutoBeschikbaarheidsvergoeding .
    ?p          ct:hasValue        ?bbv .
  }`).iterator();
  do {
    var { value, done } = await iterator.next();
    if (value !== undefined) {
      map[value.quarter[0].value.id()] = value.bbv[0].value.value;
    }
  }
  while (!done);
  return map;
}
